import styled from 'styled-components';
import { Pane, PaneContent } from "../PageStructure.component";
import pliableLogo from '@assets/images/pliable/logo_with_text_black.png'
import TenantPicker from '@components/tenant/TenantPicker.component';
import { Link } from 'react-router-dom';


const Styles  = styled.div`
    h1 {
        font-size: 2rem;
        margin-bottom: 1.5rem;
    }

    .oops {
        color: var(--brand-gray-3);
        font-size: 10rem;
        font-weight: 100;
    }
`


const TenantNotFound = () => {


    return <Styles><div className="d-flex">
        <div style={{width: '50%', height: '100vh'}} className=" border-right bg-white">
            <Pane>
                <PaneContent>
                    <div className="p-5">
                        <img src={pliableLogo} style={{width: '200px'}} className="mb-5"/>
                        <div className="oops">Oh No!</div>
                        <h1>That Tenant No Longer Exists</h1>
                        <hr />
                        <TenantPicker message='Choose a different Tenant' />   
                        <hr />
                        <Link to="/logout" className="logout-link">Logout</Link>                 
                    </div>
                </PaneContent>
            </Pane>
        </div>
    </div></Styles>
}

export default TenantNotFound;